import { colors } from '../common/colors';

export const palette = {
    background: {
        default: colors.grey4,
    },
    primary: {
        main: colors.white,
        contrastText: colors.black,
    },
};
